import { Component, OnInit } from '@angular/core';

import { NavService } from '../../core/nav.service';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss']
})
export class IntroComponent implements OnInit {
  constructor(private nav: NavService) { }

  ngOnInit() {
    this.initNav();
  }

  private initNav() {
    this.nav.title = 'Next Step';
    this.nav.actions = null;
    this.nav.slackUrl = null;
  }

}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/pages/intro/intro.component.ts